export default {
  state: {
    buyGarminEndpoint: '',
    locale: '',
    productId: '',
    defaultSku: '',
    storeCode: '',
    breadCrumbs: [],
    flashMessages: [],
  },
  getters: {
    getBuyGarminEndpoint(state) {
      return state.buyGarminEndpoint;
    },
    getLocale(state) {
      return state.locale;
    },
    getProductId(state) {
      return state.productId;
    },
    getDefaultSku(state) {
      return state.defaultSku;
    },
    getStoreCode(state) {
      return state.storeCode;
    },
    getBreadCrumbs(state) {
      return state.breadCrumbs;
    },
    getFlashMessages(state) {
      return state.flashMessages;
    },
    getProductPageApi(state, getters) {
      return `${getters.getBuyGarminEndpoint}/${getters.getLocale}/${getters.getStoreCode}/product-page/api`;
    },
  },
  mutations: {
    setBuyGarminEndpoint(state, payload) {
      state.buyGarminEndpoint = payload;
    },
    setLocale(state, payload) {
      state.locale = payload;
    },
    setProductId(state, payload) {
      state.productId = payload;
    },
    setDefaultSku(state, payload) {
      state.defaultSku = payload;
    },
    setStoreCode(state, payload) {
      state.storeCode = payload;
    },
    setBreadCrumbs(state, payload) {
      state.breadCrumbs = payload;
    },
    setFlashMessage(state, payload) {
      const msg = {};
      [msg.type, msg.text, msg.onClose] = payload;

      state.flashMessages.push(msg);
    },
    removeFlashMessage(state, index) {
      state.flashMessages = state.flashMessages.filter((msg, i) => i !== index);
    },
  },
  actions: {
    setGlobalState({ commit }, payload) {
      const {
        buyGarminEndpoint,
        locale,
        productId,
        sku,
        storeCode,
        breadCrumbs,
      } = payload;

      commit('setBuyGarminEndpoint', buyGarminEndpoint);
      commit('setLocale', locale);
      commit('setProductId', productId);
      commit('setDefaultSku', sku);
      commit('setStoreCode', storeCode);
      commit('setBreadCrumbs', breadCrumbs);
    },
    setFlashMessage({ commit }, payload) {
      commit('setFlashMessage', payload);
    },
    removeFlashMessage({ commit }, payload) {
      commit('removeFlashMessage', payload);
    },
  },
};
